import { render } from "./LayoutAuthContentsFooter.vue?vue&type=template&id=ce75f5ac&ts=true"
import script from "./LayoutAuthContentsFooter.vue?vue&type=script&lang=ts"
export * from "./LayoutAuthContentsFooter.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__